import { omit } from "ramda";
import { createApi } from "redux-future-middleware";
import { requestApi } from "core/api";
import { toFormData } from "core/utils";
import * as types from "./types";

export const getWizard = createApi({
  name: types.GET_WIZARD,
  request: () =>
    requestApi({
      path: "/user-wizards/current/",
      method: "GET"
    })
});

export const updateWizard = createApi({
  name: types.UPDATE_WIZARD,
  request: ({ body }) =>
    requestApi({
      path: "/user-wizards/current/",
      method: "PATCH",
      body: toFormData(body),
      headers: omit(["content-type"]),
      config: {
        stringify: false
      }
    })
});

export const claimDiscount = createApi({
  name: types.CLAIM_DISCOUNT,
  request: ({ code }) =>
    requestApi({
      path: `/insiders/claim-discount/?code=${code}`,
      method: "GET"
    })
});

export const insiderOnboarding = createApi({
  name: types.INSIDER_ONBOARDING,
  request: ({ body }) =>
    requestApi({
      path: `/insiders/onboarding/current/`,
      method: "PATCH",
      body
    })
});



// WEBPACK FOOTER //
// ./src/modules/user/onboarding/api.js